import { Loader, Sidebar } from 'components/common';
import TruncateText from 'components/common/TruncateText';
import UserShortCut from 'components/common/UserShortCut';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import {
  assignIntervention,
  getInterventionHistory,
} from 'features/material/services/interventionServices';
import { InterventionHistory } from 'features/material/types/interventionTypes';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface HistoryInterventionProps {
  id: number;
  parentRefetch?: () => void;
}

const HistoryIntervention: FC<SideBarProps<HistoryInterventionProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { closeSidebar } = useSidebarManager();
  const [history, setHistory] = useState<InterventionHistory[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {
    setLoading(true);
    const response = await getInterventionHistory(params.id);
    if (response.success) {
      setHistory(response.data);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };

  const handleDelete = async (userId: string) => {
    const info = {
      id: params.id,
      user_Id: '',
      description: '',
      assign: false,
      allUsers: false,
      userIds: [userId],
    };
    const response = await assignIntervention(info);
    if (response.success) {
      toast.success(t('Default.succesMessage'));
      closeSidebar(HistoryIntervention);
      fetchHistory();
      params.parentRefetch?.();
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [params.id]);

  return (
    <Sidebar
      size="m"
      type="secondary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-4 minthr-border-b minthr-border-b-3">
        <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
          <img className="minthr-icon-m" src="/icons/intervention.svg" alt="" />
        </div>
        <h3>{t('History')}</h3>

        <button
          className="minthr-sidebar-close"
          type="button"
          onClick={() => {
            closeSidebar(HistoryIntervention);
          }}
        >
          <img src="/icons/close.svg" alt="" />
        </button>
      </div>

      <div className="minthr-border-t minthr-mt-4 minthr-pt-3 minthr-mb-6 minthr-overflow-auto">
        {loading ? (
          <Loader />
        ) : (
          <>
            {history.length > 0 && (
              <div className="minthr-timeline open">
                {history.map((item) => {
                  return item.closed ? (
                    <div className="minthr-timeline-item minthr-pb-2">
                      <div className="minthr-timeline-date-icon minthr-icon-bg minthr-icon-bg-xs minthr-icon-circle ">
                        <img
                          className="minthr-icon-success minthr-icon-s"
                          src="/icons/success-icon.svg"
                          alt=""
                        />
                      </div>
                      <div
                        className={`minthr-timeline-content minthr-p-2 minthr-border-b ${item.resolved ? 'step-success' : 'step-danger'}`}
                      >
                        <div className="minthr-flex minthr-flex-items-center minthr-flex-space-between">
                          <div
                            className="minthr-mr-auto"
                            style={{ width: '50%' }}
                          >
                            <TruncateText
                              tag="div"
                              className="h5 text-s minthr-text-truncate minthr-mb-1"
                              showTooltip
                            >
                              {item.whoDid.fullName}
                            </TruncateText>
                            <span className="minthr-icon-text">
                              <img
                                className="minthr-icon-xs"
                                src="/icons/calendar.svg"
                                alt=""
                              />
                              {moment(item.date).format('DD/MM/YYYY HH:mm:ss')}
                            </span>
                            {item.description && (
                              <span className="minthr-icon-text">
                                <p
                                  className="not-all-description oneline"
                                  id="description-@cmp"
                                >
                                  {item.description}
                                </p>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="minthr-timeline-item minthr-pb-2">
                      <div className="minthr-timeline-date-icon minthr-icon-bg minthr-icon-bg-xs minthr-icon-circle minthr-bg-success-opacity">
                        <img
                          className="minthr-icon-success minthr-icon-s"
                          src="/icons/plus.svg"
                          alt=""
                        />
                      </div>
                      <div className="minthr-timeline-content minthr-p-2 minthr-border-b">
                        <div className="minthr-flex minthr-flex-items-center minthr-flex-space-between">
                          <div
                            className="minthr-mr-auto"
                            style={{ width: '50%' }}
                          >
                            <div className="h5 text-s minthr-text-truncate minthr-mb-1">
                              <span
                                className={`${item.assigned ? (item.title == 'Intervention.UnAssigned' ? 'text-danger' : 'text-success') : ''}`}
                              >
                                {t(item.title ?? '')}
                              </span>{' '}
                              {item.assigned ? item.user.fullName : ''}
                            </div>
                            <span className="minthr-icon-text">
                              <img
                                className="minthr-icon-xs"
                                src="/icons/calendar.svg"
                                alt=""
                              />
                              {moment(item.date).format('DD/MM/YYYY HH:mm:ss')}
                            </span>
                            <span className="minthr-icon-text">
                              <p
                                className="not-all-description oneline"
                                id="description-@cmp"
                              >
                                {item.description}
                              </p>
                            </span>
                          </div>
                          {item.assigned &&
                            item.active &&
                            item.title == 'Intervention.Assigned' && (
                              <a
                                className="Anassign minthr-m-4"
                                onClick={() => {
                                  handleDelete(item.user.id);
                                }}
                              >
                                <img
                                  src="/icons/trash-light-green.svg"
                                  className="deleteAffectation"
                                  alt=""
                                />
                              </a>
                            )}
                          <UserShortCut
                            src={`upload/profileimages/${item?.whoDid?.id}/${item?.whoDid?.picturePath}`}
                            alt={item?.whoDid?.fullName ?? ''}
                            className="minthr-avatar minthr-avatar-m"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    </Sidebar>
  );
};

export default HistoryIntervention;
